"use client";

import { useAuth } from "@/hooks/useAuth";
import { getSignIn } from "@/lib/auth-actions";
import { UserMenu } from "./UserMenu";

interface AuthButtonsProps {
  variant?: "desktop" | "mobile";
}

export function AuthButtons({ variant = "desktop" }: AuthButtonsProps) {
  const { isLoading, isAuthenticated, user } = useAuth();

  const handleSignIn = async () => {
    const signInUrl = await getSignIn();
    window.location.href = signInUrl;
  };

  if (isLoading) {
    return (
      <div className="h-9 w-20 animate-pulse rounded-lg bg-muted" />
    );
  }

  if (isAuthenticated && user) {
    return <UserMenu />;
  }

  return (
    <button
      onClick={handleSignIn}
      className={
        variant === "mobile"
          ? "text-sm font-bold text-foreground/80 hover:text-primary transition-colors cursor-pointer"
          : "text-[13px] font-bold text-foreground/70 tracking-wide hover:text-primary transition-colors cursor-pointer"
      }
    >
      Log in
    </button>
  );
}
